import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { protectedApi } from '../../services/api';

// Thunks
export const fetchCarouselImages = createAsyncThunk(
  'carousel/fetchCarouselImages',
  async () => {
    try {
      const response = await protectedApi.getCarouselImages();
      return response.data;
    } catch (err) {
      console.error('Error fetching carousel images:', err);
      throw err;
    }
  }
);

export const createCarouselImage = createAsyncThunk(
  'carousel/createCarouselImage',
  async (bannerData, { rejectWithValue }) => {
    try {
      const response = await protectedApi.createCarouselImage(bannerData);
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue({ detail: err.message });
    }
  }
);

export const deleteCarouselImage = createAsyncThunk(
  'carousel/deleteCarouselImage',
  async (id, { rejectWithValue }) => {
    try {
      await protectedApi.deleteCarouselImage(id);
      return id;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue({ detail: err.message });
    }
  }
);

// Slice
const carouselSlice = createSlice({
  name: 'carousel',
  initialState: {
    images: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch images cases
      .addCase(fetchCarouselImages.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCarouselImages.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.images = action.payload;
        state.error = null;
      })
      .addCase(fetchCarouselImages.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // Create image cases
      .addCase(createCarouselImage.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createCarouselImage.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.images.push(action.payload);
        state.error = null;
      })
      .addCase(createCarouselImage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.detail || action.error.message;
      })
      // Delete image cases
      .addCase(deleteCarouselImage.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deleteCarouselImage.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.images = state.images.filter(image => image.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteCarouselImage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.detail || action.error.message;
      });
  },
});

export const { clearError } = carouselSlice.actions;
export default carouselSlice.reducer;
